module.exports = __webpack_public_path__ + "static/media/visa.6c28d631.svg";